module.exports = __webpack_public_path__ + "static/media/tutellus.34ac67ab.png";